import store from '@/store';

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.prototype.$audio = new Player();
  }
}

class Player {
  #sounds;
  #files;

  constructor() {
    // The sounds by name, and their files in assets/ (message: the chat's, SPEC §5.6).
    this.#files = { stone: 'stone.mp3', message: 'message.wav' };
    this.#sounds = { stone: null, message: null };

    this.#load();
  }

  async #load() {
    for(const name in this.#sounds) {
      const file = await import(`@/assets/${this.#files[name]}`);
      const aud = new Audio(file.default);
      this.#sounds[name] = aud;
    }
  }

  async play(name) {
    if(store.state.ui && store.state.ui.soundEffect === 0)
      return;

    const aud = this.#sounds[name];
    if(aud) {
      try {
        aud.load();
        await aud.play();
        console.log(`Audio ${name} played`);
      } catch(e) {
        console.log(`Audio ${name} not played: ${e}`);
      }
    } else {
      console.log(`Audio ${name} not played: not loaded`);
    }
  }
}
